import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconButtonComponent } from '@examdojo/core/icon-button';
import { MarkCalculationMethod } from '@examdojo/models/markscheme-v2';
import { QuestionItemsPreviewComponent } from '@examdojo/question';
import { IonContent, IonHeader, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { ReferenceQuestionUIModel } from '../reference-question.model';

@Component({
  selector: 'dojo-reference-question-popup',
  template: `
    <ion-header [translucent]="true" class="shadow-none">
      <ion-toolbar class="toolbar-with-closing-button !px-2 md:!px-4">
        <div slot="start" class="md:flex">
          <dojo-icon-button (click)="closeDialog()" [icon]="'times'" />
        </div>
        <ion-title class="common-ion-title">Reference Question</ion-title>
        <div slot="end" class="hidden md:flex md:w-8"></div>
      </ion-toolbar>
    </ion-header>
    <ion-content [scrollY]="false">
      <div class="flex h-full w-full">
        @if (referenceQuestion(); as referenceQuestion) {
          <div class="flex h-full w-full flex-col">
            <div class="border-b border-neutral-200 p-4">
              <div class="text-sm text-neutral-600">
                Reference Question #{{ referenceQuestion.question_number }}
                <span class="ml-2 text-xs">(ID: {{ referenceQuestion.id }})</span>
              </div>
              @if (referenceQuestion.source_ref) {
                <div class="text-xs text-neutral-500">
                  {{ referenceQuestion.source_ref.course }} - {{ referenceQuestion.source_ref.year }} -
                  {{ referenceQuestion.source_ref.month }} - Paper {{ referenceQuestion.source_ref.paper }}
                </div>
              }
            </div>
            <div class="flex-1 overflow-y-auto p-4">
              <dojo-question-items-preview
                [questionItems]="questionItems()"
                [markCalculationMethod]="markCalculationMethod()"
                [calculatorAllowed]="calculatorAllowed()"
              />
            </div>
          </div>
        } @else {
          <div class="flex h-full w-full items-center justify-center text-neutral-500">
            No reference question data available
          </div>
        }
      </div>
    </ion-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonHeader, IonContent, IonToolbar, IconButtonComponent, IonTitle, QuestionItemsPreviewComponent],
})
export class ReferenceQuestionPopupComponent {
  constructor(private readonly modalCtrl: ModalController) {}

  readonly referenceQuestion = input.required<ReferenceQuestionUIModel>();
  readonly markCalculationMethod = input.required<MarkCalculationMethod>();
  readonly questionItems = computed(() => this.referenceQuestion().question_items);
  readonly calculatorAllowed = computed(() => this.referenceQuestion().metadata?.calculator_allowed ?? false);

  closeDialog() {
    this.modalCtrl.dismiss();
  }
}
